import { createGlobalStyle } from "styled-components";

export const HeaderCss = createGlobalStyle`
    .header {
        padding: 1rem 4rem !important;
    }
    .header-brand {
        font-size: 2.5rem;
        font-family: ${({ theme }) => theme.fontFamily.overpassSB};
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        color: #4f5d73;
    }
`;
